import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Link,
  Typography,
} from "@mui/material";
import { useWebApiV1GetTenantConfigQuery } from "@providers/hop-ord-server/api";
import { supportEmail as defaultSupportEmail } from "@constants";
import { LoadingIcon } from "@components/LoadingIcon";

const ErrorAlert = ({ open }: { open: boolean }) => {
  const { data: tenantConfig, isLoading } = useWebApiV1GetTenantConfigQuery();

  const supportEmail =
    tenantConfig?.support_email?.trim() || defaultSupportEmail;

  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          sx: {
            minWidth: 400,
          },
        },
      }}
      maxWidth="xs"
      sx={{ letterSpacing: "0.15px" }}
    >
      <DialogTitle>Something went wrong</DialogTitle>
      {isLoading ? (
        <LoadingIcon />
      ) : (
        <DialogContent>
          We have encountered an error. Please attempt to resolve by refreshing
          the page. If the issue persists, please contact Lumonus IT support at{" "}
          <Link
            data-testid="support-email"
            href={supportEmail ? `mailto:${supportEmail}` : ""}
          >
            {supportEmail}
          </Link>
          <Typography sx={{ mt: 3 }}>
            Our team is working on this matter.
          </Typography>
          <Typography>We appreciate your patience.</Typography>
        </DialogContent>
      )}
      <DialogActions>
        <Button
          onClick={() => window.location.reload()}
          data-testid="refresh-button"
        >
          Refresh
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorAlert;
